import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Input, Button, message } from "antd";
import { LockOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import logo from "../../../Assets/Images/Logo.svg";
import "./style.css";
import { resetPasswordAPI } from "../../../API/auth";

const ResetPassword = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { token } = useParams();

  const onFinish = async (values) => {
    if (values.new_password !== values.confirm_password) {
      message.error("Passwords do not match!");
      return;
    }

    setLoading(true);

    const payload = {
      token: token,
      new_password: values.new_password,
    };

    const response = await resetPasswordAPI(payload);

    if (Math.floor(response?.status / 100) === 2) {
      message.success("Password reset successfully!");
      navigate("/login");
    } else {
      message.error(response?.data?.error || "Something went wrong");
    }

    setLoading(false);
  };

  const handleBack = () => {
    navigate("/login");
  };

  return (
    <div className="reset">
      <div className="reset-page">
        <div className="logo">
          <img src={logo} alt="logo" />
        </div>

        <div className="reset-card">
          <div className="content">
            <div className="content-heading">Reset Your Password</div>
            <div className="sub-heading">Enter your new password below</div>

            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item
                label="New Password"
                name="new_password"
                rules={[
                  { required: true, message: "Please enter new password!" },
                  { min: 8, message: "Password must be at least 8 characters" },
                ]}
              >
                <Input.Password
                  placeholder="Enter new password"
                  prefix={<LockOutlined />}
                />
              </Form.Item>

              <Form.Item
                label="Confirm Password"
                name="confirm_password"
                rules={[
                  { required: true, message: "Confirm your password!" },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue("new_password") === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(
                        new Error("Passwords do not match")
                      );
                    },
                  }),
                ]}
              >
                <Input.Password
                  placeholder="Confirm password"
                  prefix={<LockOutlined />}
                />
              </Form.Item>

              <Button
                type="primary"
                htmlType="submit"
                className="submit-button"
                loading={loading}
              >
                Reset Password
              </Button>
            </Form>
          </div>
        </div>
        <div className="back-to-login" onClick={handleBack}>
          <ArrowLeftOutlined />
          Back to Login
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
